<div>
  <div>
    <app-empresa-dropdown [(selecionadas)]="instanciaSelecionada" (funcaoChange)="onInstanciaChange($event)" />
     <!-- <p-multiSelect
      appendTo="body"
      [options]="instancias"
      [filter]="true"
      [style]="{ width: '200px' }"
      optionValue="id"
      optionLabel="nome"
      [(ngModel)]="instanciaSelecionada"
      dataKey="id"
      inputId="id"
      placeholder="Instância"
      emptyMessage="Nenhuma instância"
      (onChange)="onInstanciaChange($event)"
    > 
    </p-multiSelect> -->
    <p-button
        class="ml-3"
        *ngIf="habilitaBusca"
        pRipple
        icon="pi pi-refresh"
        label="Buscar Contratos"
        [loading]="loadingSincronizar"
        [disabled]="loading"
        (onClick)="buscarContratos()"
      ></p-button>

      <p-button
        class="ml-3"
        *ngIf="habilitaIntegracao"
        pRipple
        icon="pi pi-arrow-up-right"
        label="Integrar Selecionados"
        [loading]="loadingSincronizar"
        [disabled]="loading"
        (onClick)="integrar()"
      ></p-button>

    <p-button
      class="ml-3"
      *ngIf="habilitaCancelamento"
      pRipple
      icon="pi pi-arrow-up-right"
      label="Cancelar no ERP"
      [loading]="loadingSincronizar"
      [disabled]="loading"
      (onClick)="cancelar()"
    ></p-button>

      <p-button
        class="ml-3"
        *ngIf="habilitaExportacao"
        pRipple
        icon="pi pi-file-excel"
        label="Exportar"
        [loading]="loadingSincronizar"
        [disabled]="loading"
        (onClick)="exportar()"
      ></p-button>

      <p-calendar
        *ngIf="habilitaData"
        class="ml-3"
        [(ngModel)]="dataBaixa"
        dateFormat="dd/mm/yy"
        placeholder="Data de baixa"
        [showIcon]="true"
        [readonlyInput]="true"
      ></p-calendar>
<!-- (onLazyLoad)="onInstanciaChange($event)" [lazy]="true" -->
    <div class="mt-3">
      <p-table
        [value]="contratos"

        dataKey="idContrato"
        [(selection)]="contratosSelecionados"
        #dtContratos
        [globalFilterFields]="['idContrato','instancia','cdEmpresaErp','dtInicVigencia','dtFinVigencia','cdFornecErp','cdUpnivel1']"
        [paginator]="true"
        [rows]="1000"
        [showCurrentPageReport]="true"
        currentPageReportTemplate="Registros selecionados: {{ contratosSelecionados.length }} | Mostrando de {first} até {last} de {totalRecords} registros"
        [rowsPerPageOptions]="[20, 50, 100, 500, 1000, 10000]"
        [totalRecords]="totalRecords"
        [loading]="loading"
        styleClass="p-datatable-sm p-datatable-striped p-datatable-gridlines"
        [scrollable]="true"
        scrollHeight="40.5rem"
        [resizableColumns]="true"
        [tableStyle]="{
          'font-size': '.9rem',
          'font-weight': '400',
          'border-spacing': '0 0 !important',
          'border-colapse': 'separate'
        }"
        #dt
        (onRowSelect)="onRowSelect($event)"
        selectionMode="multiple"
      >
      <ng-template pTemplate="caption">
        <div class="flex">

            <span class="p-input-icon-left ml-auto">
                <i class="pi pi-search"></i>
                <input pInputText type="text" [(ngModel)]="termo" (input)="dt.filterGlobal($any($event.target)?.value, 'contains')" placeholder="Pesquisar" />
            </span>
        </div>
    </ng-template>

        <ng-template pTemplate="header">
          <tr>
            <tr>
              <th style="width: 4rem"><p-tableHeaderCheckbox />
            </th>
            <th pSortableColumn="idContrato">
              Contrato <p-sortIcon field="idContrato"></p-sortIcon>
            </th>
            <th pSortableColumn="instancia">
              Instância <p-sortIcon field="instancia"></p-sortIcon>
            </th>
            <th pSortableColumn="cdEmpresaErp">
              Empresa ERP <p-sortIcon field="cdEmpresaErp"></p-sortIcon>
            </th>
            <th pSortableColumn="dtInicVigencia">
              Inicio Vigência <p-sortIcon field="dtInicVigencia"></p-sortIcon>
            </th>
            <th pSortableColumn="dtFinVigencia">
              Fim Vigência <p-sortIcon field="dtFinVigencia"></p-sortIcon>
            </th>
            <th pSortableColumn="cdFornecErp">
              Fornecedor <p-sortIcon field="cdFornecErp"></p-sortIcon>
            </th>
            <th pSortableColumn="cdUpnivel1">
              Fazenda <p-sortIcon field="cdUpnivel1"></p-sortIcon>
            </th>
            <th pSortableColumn="diaPagto">
              Dia Pagamento <p-sortIcon field="diaPagto"></p-sortIcon>
            </th>
<!--            <th pSortableColumn="fgStatusInteg">-->
<!--              Status <p-sortIcon field="fgStatusInteg"></p-sortIcon>-->

<!--              <p-columnFilter field="fgStatusInteg" matchMode="in" display="menu" [showApplyButton]="false" [showClearButton]="false" [showMatchModes]="false" [showOperator]="false" [showAddButton]="false">-->

<!--                <ng-template pTemplate="filter" let-value let-filter="filterCallback" >-->
<!--                    <p-multiSelect [ngModel]="value" selectedItemsLabel="Vários selecionados" [options]="status" placeholder="Todos" [filter]="true"  optionValue="value" (onChange)="filter($event.value)" optionLabel="name">-->

<!--                        <ng-template let-option pTemplate="item">-->
<!--                            <div class="inline-block vertical-align-middle">-->
<!--                                <span class="ml-1 mt-1">{{ option.name }}</span>-->
<!--                            </div>-->
<!--                        </ng-template>-->

<!--                    </p-multiSelect>-->
<!--                </ng-template>-->

<!--                <ng-template pTemplate="clearfiltericon">-->

<!--                </ng-template>-->
<!--            </p-columnFilter>-->
<!--            </th>-->
            <th></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-contrato>
          <tr>
            <td><p-tableCheckbox [value]="contrato" /></td>
            <td>{{ contrato.idContrato }}</td>
            <td>{{ contrato.instancia }}</td>
            <td>{{ contrato.cdEmpresaErp }}</td>
            <td>{{ contrato.dtInicVigencia | date : "dd/MM/yyyy" }}</td>
            <td>{{ contrato.dtFinVigencia | date : "dd/MM/yyyy" }}</td>
            <td>{{ contrato.cdFornecErp }}</td>
            <td>{{ contrato.cdUpnivel1 }}</td>
            <td>{{ contrato.diaPagto }}</td>
<!--            <td>{{ contrato.fgStatusInteg }} </td>-->
            <td><p-button icon="pi pi-eye" severity="primary" class="m-2" [rounded]="true" [text]="true" size="small" (onClick)="exibeContrato(contrato)" > </p-button></td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <td colspan="21">Nenhum registro encontrado</td>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>

<p-confirmDialog header="Confirmation" width="425"></p-confirmDialog>

<app-contrato [dialog]="contratoDialog" [contrato]="contratoSelecionado" (fechar)="escondeDialog()"></app-contrato>
